import { createRouter, createWebHashHistory } from 'vue-router';

const routes: any[] = [
  { component: () => import('../features/shifts/ShiftView.vue'), name: 'shift', path: '/' },
  { path: '/log', redirect: '/' },
  { path: '/history', redirect: '/planner' },
  {
    component: () => import('../features/planner/PlannerPanel.vue'),
    name: 'planner',
    path: '/planner',
  },
  {
    component: () => import('../features/settings/SettingsView.vue'),
    name: 'settings',
    path: '/settings/:tab?/:id?',
  },
  { component: () => import('@/features/ocr/OcrView.vue'), name: 'ocr', path: '/ocr' },
  {
    component: () => import('@/features/reports/ReportsView.vue'),
    name: 'reports',
    path: '/reports/:tab?/:id?',
  },
  { component: () => import('@/features/legal/TermsOfService.vue'), name: 'terms', path: '/terms' },
  {
    component: () => import('@/features/legal/PrivacyPolicy.vue'),
    name: 'privacy',
    path: '/privacy',
  },
  // Public, unauthenticated -- visited by a client who received an invoice link by email, not
  // the tenant's own device. App.vue renders this standalone, without LiveStoreProvider/AppShell
  // -- this visitor has no local app data and shouldn't pay the cost of an offline-first local
  // database spinning up just to view one invoice.
  {
    component: () => import('@/features/invoicing/PublicInvoiceView.vue'),
    name: 'public-invoice',
    path: '/invoice/:id',
  },
];

export const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
